// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-item {
  border: 1px solid rgba(223, 223, 223, 0.37);
}

.icon-delete {
  position: absolute;
  top: 0;
  right: 0;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+kanban/board/comment-item/comment-item.component.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AACF;;AACA;EACE,kCAAA;AAEF","sourcesContent":[".comment-item {\r\n  border: 1px solid rgba(223, 223, 223, 0.37);\r\n}\r\n\r\n.icon-delete {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
